import { eFormApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const getEFormGenerationStatus = () => {
    const url = eFormApi.EFORM_GENERATION_STATUS;
    return axios.get(url);
};


export const eFormDownload = (fileType) => {
    const url = `${eFormApi.DOWNLOAD_EFORM}/${fileType}`;
    return axios.get(url, { responseType: 'blob' });
}